export const ErrorTypeEnum = Object.assign({
  NOT_FOUND: "Not found",
  BAD_REQUEST_PARAMETERS: "Bad request parameters",
  NOT_CREATED: "Not createds",
  NOT_MODIFIED: "Not modified",
  FORBIDDEN: "Forbidden"
});
